import { CircularProgress, Dialog, Flex, Text, DialogContent } from '@shared/components';

export default function ExamAssigningLoadingModal() {
  return (
    <Dialog open sx={{ '& .MuiPaper-root': { width: '420px' } }}>
      <DialogContent>
        <Flex
          sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4), alignItems: 'center' }}
        >
          <CircularProgress size={48} />
          <Flex
            sx={{
              flexDirection: 'column',
              alignItems: 'center',
              gap: (theme) => theme.spacing(1),
            }}
          >
            <Text variant='h5'>กำลังมอบหมายชุดข้อสอบ</Text>
            <Text>กรุณารอสักครู่ ระบบกำลังมอบหมายชุดข้อสอบให้รอบสอบ</Text>
          </Flex>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
